import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter, Link, matchPath } from 'react-router-dom'
import PropTypes from 'prop-types'
import delayP from 'delay'
import { crypto } from '@binance-chain/javascript-sdk'

import { TOKEN_TYPE_BEP8, getTokenType } from 'utils/tokenTypes'
import { isMiniTokenEnabled } from 'utils/env'
import { Consumer as WalletConnectClient } from '../context/WalletConnectProvider'
import Icon from '../../components/common/Icon'
import Confirm from '../../components/common/Confirm'
import message from '../../components/common/Message'
import IntervalDate from '../../components/common/IntervalDate'
import NetWork from '../../components/common/NetWork'

import { setNeedAuth } from '../../redux/account/action'
import { setTriggerElement, setShowIpValidation } from '../../redux/global/action'

import { EXPLORER_URL, NETWORK_ENV } from '../../utils/httpRequest'
import { downloadKeystore, isUnlockWithWalletConnect } from '../../utils/account'

import { setShowTradePairsMobile } from '../../redux/exchange/action'
import { setWalletConnectURI } from '../../redux/walletConnect/action'
import { setFavorites } from '../../redux/tradePairs/action'

import MenuMobile from '../../components/mobile/MenuMobile'
import ConfirmPasswordModalHost from '../modals/ConfirmPasswordModalHost'
import CreateWalletModal from '../createWallet'
import UnlockWalletModal from '../unlockWallet'
import WalletInfo from '../walletinfo'
import withExtensionWallet from '../../hooks/useExtensionWallet'

import { isMobile } from '../../utils/bomUtils'

import isElectron from '../../utils/isElectron'
import { isTokenManagementEnabled } from '../../utils/isTokenManagementEnabled'

import SelectLang from '../../i18n/containers/SelectLang'
import { withI18n } from '../../i18n/util'

import testnetSvg from '../../static/images/logo/testnet.svg'
import mainnetSvg from '../../static/images/logo/mainnet.svg'
import mobileLogoSvg from '../../static/images/logo/mobile.svg'
import electronLogoSvg from '../../static/images/logo/trubi.svg'
import {
  Wrapper,
  StyledSelectLang,
  LeftPane,
  Logo,
  DateNetWork,
  RightPane,
  Menu,
  MobileMenuIcon,
  ConfirmContent,
  CancelImg,
  SubMenus,
  MobileItemBox,
  SearchWrap,
  FavoriteIcon,
  MobileItemTradePair,
  MobileItemMoreTradePair,
  MiniTokenTag,
} from './styled'

const logoUrl = (() => {
  if (isMobile()) return mobileLogoSvg
  if (isElectron()) return electronLogoSvg
  if (NETWORK_ENV === 'testnet') return testnetSvg
  return mainnetSvg
})()

class Header extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    privateKey: PropTypes.string,
    address: PropTypes.string,
    encryptedData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    currentTrade: PropTypes.string,
    cipher: PropTypes.string,
    needAuth: PropTypes.bool,
    withOpenOrders: PropTypes.bool,
    withTradePairs: PropTypes.bool,
    history: PropTypes.object.isRequired,
    formatI18nText: PropTypes.func,
    bgColor: PropTypes.string,
    isIpValid: PropTypes.bool,
    isShowIpValidation: PropTypes.bool,
    isConnectedWithWallet: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired,
    favorites: PropTypes.array,
    className: PropTypes.string,
    flags: PropTypes.object,
    location: PropTypes.object,
    deviceInfo: PropTypes.object,
  }

  static defaultProps = {
    dispatch: () => {},
    privateKey: '',
    address: '',
    encryptedData: null,
    currentTrade: '',
    cipher: '',
    needAuth: false,
    withOpenOrders: true,
    withTradePairs: false,
    formatI18nText: () => {},
    bgColor: '',
    isIpValid: true,
    isShowIpValidation: false,
    isConnectedWithWallet: false,
    favorites: [],
    className: '',
    flags: {},
    location: {},
    deviceInfo: {},
  }

  constructor(props) {
    super(props)
    this._onConnect = this._onConnect.bind(this)
  }

  state = {
    confirmLogout: false,
    showMobileMenu: false,
    showSearchIcon: false,
    showCreateWalletModal: false,
    showUnlockWalletModal: false,
  }

  componentDidMount() {
    const {
      match: { path },
    } = this.props
    this.setState({ showSearchIcon: path[0] === '/:locale/' })
  }

  componentWillUnmount() {
    this.dateTimeHandler && clearInterval(this.dateTimeHandler)
  }

  _confirmSignout = wcClient => () => {
    if (isUnlockWithWalletConnect()) {
      wcClient && wcClient.disconnect()
    }

    sessionStorage.removeItem('user')
    window.localStorage.removeItem('walletconnect')
    window.location.reload()
  }

  _copyAddress = () => {
    const { formatI18nText } = this.props
    message.info(formatI18nText('header.user.copySuccess'))
  }

  _exportKeyStore = ev => {
    const { dispatch, privateKey, cipher, needAuth } = this.props
    if (!needAuth) {
      dispatch(setNeedAuth(true))
      dispatch(setTriggerElement(ev.currentTarget))
    }

    if (needAuth && privateKey) {
      const keyStore = crypto.generateKeyStore(privateKey, cipher)
      downloadKeystore(keyStore)
    }
  }

  _getMenus = () => {
    const { withOpenOrders, address, locale } = this.props
    const subMenus = [
      { text: 'Order History', i18nId: 'header.orderHistory', path: `/${locale}/orderHistory` },
      { text: 'Trade History', i18nId: 'header.tradeHistory', path: `/${locale}/tradeHistory` },
    ]

    if (withOpenOrders) {
      subMenus.unshift({
        text: 'Open Orders',
        i18nId: 'header.openOrders',
        path: `/${locale}/openOrders`,
      })
    }

    subMenus.push({
      text: 'Fee History',
      i18nId: 'header.feeHistory',
      path: `/${locale}/feeHistory`,
    })

    const loginedMenus = [
      {
        text: 'Transactions',
        i18nId: 'header.transactions',
        path: `/${locale}/transactionHistory`,
      },
      { text: 'Balances', i18nId: 'header.balances', path: `/${locale}/balances` },
    ]

    if (!isTokenManagementEnabled) {
      loginedMenus.unshift({ text: 'Orders', i18nId: 'header.orders', subMenus })
      if (isMiniTokenEnabled) {
        loginedMenus.unshift({
          text: 'Market',
          i18nId: 'header.exchange',
          subMenus: [
            {
              text: 'BEP2',
              i18nId: 'header.exchange.menu.bep2',
              path: `/${locale}/trade`,
              external: true,
            },
            {
              text: 'BEP8',
              i18nId: 'header.exchange.menu.bep8',
              path: `/${locale}/trade/mini`,
            },
          ],
        })
      } else {
        loginedMenus.unshift({
          text: 'Market',
          i18nId: 'header.exchange',
          path: `/${locale}/trade`,
        })
      }
    }

    if (isTokenManagementEnabled && isElectron()) {
      loginedMenus.push({ text: 'Tokens', i18nId: 'Tokens', path: `/${locale}/tokens` })
    }

    const unLoginedMenus = []

    if (!isTokenManagementEnabled) {
      if (isMiniTokenEnabled) {
        unLoginedMenus.push({
          text: 'Market',
          i18nId: 'header.exchange',
          subMenus: [
            {
              text: 'BEP2',
              i18nId: 'header.exchange.menu.bep2',
              path: `/${locale}/trade`,
              external: true,
            },
            { text: 'BEP8', i18nId: 'header.exchange.menu.bep8', path: `/${locale}/trade/mini` },
          ],
        })
      } else {
        unLoginedMenus.push({
          text: 'Market',
          i18nId: 'header.exchange',
          path: `/${locale}/trade`,
        })
      }
    }

    unLoginedMenus.push({
      text: 'Create New Wallet',
      i18nId: 'header.createWallet',
      onClick: () => this._setCreateWalletModal(true),
    })
    unLoginedMenus.push({
      text: 'Unlock Wallet',
      i18nId: 'header.unlockWallet',
      onClick: () => this._onClickUnlock(),
    })

    return address ? loginedMenus : unLoginedMenus
  }

  _showMobileMenu = () => {
    this.setState({ showMobileMenu: true })
  }

  _hideMobileMenu = () => {
    this.setState({ showMobileMenu: false })
  }

  _showTradepairs = () => {
    const { dispatch } = this.props
    dispatch(setShowTradePairsMobile(true))
  }

  _showConfirmLogout = () => {
    this.setState({ confirmLogout: true })
  }

  _setCreateWalletModal = bool => {
    const { dispatch, isIpValid, isShowIpValidation } = this.props
    if (!isIpValid && !isShowIpValidation) {
      dispatch(setShowIpValidation(true))
      return
    }

    this.setState({ showCreateWalletModal: !!bool })
  }

  _setUnlockWalletModal = bool => {
    const { dispatch, isIpValid, isShowIpValidation } = this.props
    if (!isIpValid && !isShowIpValidation) {
      dispatch(setShowIpValidation(true))
      return
    }

    this.setState({ showUnlockWalletModal: !!bool })
  }

  _onClickUnlock = () => {
    const { history, locale, location } = this.props
    const match = matchPath(location.pathname, {
      path: '/:locale/tokens',
    })

    if (match && match.url.includes(`/${locale}/tokens`)) {
      history.push(`/${locale}/unlock?tokens=true`)
    } else {
      this._setUnlockWalletModal(true)
    }
  }

  _clickLogo = () => {
    const { locale } = this.props
    if (!isElectron()) {
      window.location.href = `/${locale}`
    }
  }

  _unlockWalletConnect = async walletConnectClient => {
    const { dispatch } = this.props
    window.localStorage.removeItem('walletconnect')

    if (walletConnectClient.connected()) {
      walletConnectClient.disconnect()
      await delayP(1000) // to be safe because we cannot await on disconnect
    }
    const uri = await walletConnectClient.startSession(false)
    if (window.__DEV__) {
      console.log('WalletConnect URI', uri)
    }
    dispatch(setWalletConnectURI(uri))
    walletConnectClient.on('connect', this._onConnect)
  }

  _onConnect = async () => {
    this._setUnlockWalletModal(false)
  }

  _getFavoriteIcon = () => {
    const { currentTrade, favorites } = this.props
    const isInFavorites = !!favorites?.find(f => currentTrade.replace('_', '/') === f)
    return isInFavorites ? 'starfilled' : 'staroutlined'
  }

  _addFavorite = () => {
    const { favorites, dispatch, currentTrade } = this.props
    const key = currentTrade.replace('_', '/')
    if (!favorites?.find(f => f === key)) {
      favorites.push(key)
    } else {
      for (let i = 0, len = favorites.length; i < len; i++) {
        if (favorites[i] === key) {
          favorites.splice(i, 1)
        }
      }
    }

    dispatch(setFavorites(favorites))
  }

  render() {
    const {
      confirmLogout,
      showMobileMenu,
      showSearchIcon,
      showCreateWalletModal,
      showUnlockWalletModal,
    } = this.state

    const {
      address,
      currentTrade,
      withTradePairs,
      className,
      formatI18nText,
      bgColor,
      isIpValid,
    } = this.props

    const pair = currentTrade.split('_')
    const menus = this._getMenus()

    const menusElements = menus.map((menu, index) => {
      if (menu.subMenus) {
        return (
          <li className="withSubMenus" key={menu.text}>
            <span>{formatI18nText(menu.i18nId)}</span>
            <SubMenus className="subMenus">
              {menu.subMenus.map(sm => {
                return (
                  <>
                    {sm.external ? (
                      <li key={sm.text}>
                        <a href={sm.path}>{formatI18nText(sm.i18nId)}</a>
                      </li>
                    ) : (
                      <li key={sm.text}>
                        <Link to={sm.path}>{formatI18nText(sm.i18nId)}</Link>
                      </li>
                    )}
                  </>
                )
              })}
            </SubMenus>
            <i className="triangle" />
          </li>
        )
      }
      return (
        <li key={menu.text}>
          {menu.path && (
            <Link to={menu.path}>
              <span>{formatI18nText(menu.i18nId)}</span>
            </Link>
          )}
          {menu.onClick && (
            <a onClick={menu.onClick} onKeydown={menu.onClick} role="button" tabIndex={index}>
              {formatI18nText(menu.i18nId)}
            </a>
          )}
        </li>
      )
    })

    const favoriteIcon = this._getFavoriteIcon()

    /* eslint-disabled */
    return (
      <WalletConnectClient>
        {wcClient => (
          <Wrapper className={className} bgColor={bgColor}>
            <LeftPane>
              <Logo onClick={this._clickLogo}>
                <img src={logoUrl} alt="" />
              </Logo>
              {getTokenType() === TOKEN_TYPE_BEP8 && <MiniTokenTag />}
              {!isMobile() && (
                <DateNetWork>
                  <IntervalDate />
                  <NetWork />
                </DateNetWork>
              )}
              {withTradePairs && pair[0] && (
                <MobileItemBox onClick={this._showTradepairs}>
                  <MobileItemTradePair>
                    {pair[0].replace(/-[A-F0-9]+/g, '')}
                    {' / '}
                    {pair[1].replace(/-[A-F0-9]+/g, '')}
                    <MobileItemMoreTradePair onClick={this._showTradepairs}>
                      <Icon type="sanjiaojiantouxia-B" color="#f0b90b" />
                    </MobileItemMoreTradePair>
                  </MobileItemTradePair>
                </MobileItemBox>
              )}
              {withTradePairs && (
                <FavoriteIcon onClick={this._addFavorite}>
                  <Icon type={favoriteIcon} color="#f0b90b" size={20} />
                </FavoriteIcon>
              )}
            </LeftPane>
            <RightPane>
              <Menu>
                <li>
                  <a href={EXPLORER_URL} {...(isElectron() ? { target: '_blank' } : {})}>
                    {formatI18nText('header.explorer')}
                  </a>
                </li>
                {menusElements}
              </Menu>
              {address && (
                <WalletInfo
                  unlock={() => this._onClickUnlock()}
                  disconnect={this._showConfirmLogout}
                />
              )}
              <StyledSelectLang>
                <SelectLang overlayClassName="header-dropdown-overlay" />
              </StyledSelectLang>
              {!isElectron() && (
                <Menu>
                  <li className="withSubMenus">
                    <Icon type="detail-D" />
                    <SubMenus className="subMenus">
                      <li>
                        <a href="https://docs.binance.org/">{formatI18nText('header.faq')}</a>
                      </li>
                      <li>
                        <a href="https://community.binance.org/">
                          {formatI18nText('header.forums')}
                        </a>
                      </li>
                      <li>
                        <a href="https://www.binance.org/en/blog/">
                          {formatI18nText('header.blog')}
                        </a>
                      </li>
                      {NETWORK_ENV === 'mainnet' ? (
                        <li>
                          <a href="https://testnet.binance.org">
                            {formatI18nText('header.testnet')}
                          </a>
                        </li>
                      ) : (
                        <li>
                          <a href="https://www.binance.org">{formatI18nText('header.mainnet')}</a>
                        </li>
                      )}
                    </SubMenus>
                  </li>
                </Menu>
              )}
              <MobileMenuIcon onClick={this._showMobileMenu}>
                <Icon type="menu" size={20} />
              </MobileMenuIcon>
              {isMobile() && showSearchIcon && (
                <SearchWrap onClick={this._showTradepairs}>
                  <Icon type="search" color="#828A98" size="24" />
                </SearchWrap>
              )}
            </RightPane>
            {showMobileMenu && (
              <MenuMobile
                address={address}
                close={this._hideMobileMenu}
                closeWallet={this._showConfirmLogout}
                isIpValid={isIpValid}
              />
            )}
            {confirmLogout && (
              <Confirm
                cancelText={formatI18nText('common.cancel')}
                okText={formatI18nText('common.confirm')}
                confirm={this._confirmSignout(wcClient)}
                cancel={() => {
                  this.setState({ confirmLogout: false })
                }}
              >
                <ConfirmContent>
                  <CancelImg />
                  <p>{formatI18nText('header.youWantCloseWallet')}</p>
                </ConfirmContent>
              </Confirm>
            )}
            {/* !isMobile() &&
                <Notifycation /> */}
            <ConfirmPasswordModalHost />
            <CreateWalletModal
              open={showCreateWalletModal}
              onClose={() => this._setCreateWalletModal(false)}
            />
            <UnlockWalletModal
              open={showUnlockWalletModal}
              onClose={() => this._setUnlockWalletModal(false)}
              onClickUnlock={() => this._unlockWalletConnect(wcClient)}
            />
          </Wrapper>
        )}
      </WalletConnectClient>
    )
  }
}

const mapStateToProps = ({
  account: { privateKey, needAuth, address, encryptedData, cipher, flags },
  exchange: { currentTrade },
  globalData,
  walletConnect: { isConnectedWithWallet },
  tradePairs: { favorites },
}) => ({
  needAuth,
  privateKey,
  address,
  encryptedData,
  cipher,
  currentTrade,
  flags,
  isIpValid: globalData.isIpValid,
  isShowIpValidation: globalData.isShowIpValidation,
  isConnectedWithWallet,
  favorites,
  deviceInfo: globalData,
})

export default withI18n(connect(mapStateToProps)(withRouter(withExtensionWallet(Header))))
